export default __webpack_public_path__ + "static/img_3-7570beee46eb2688ed0e7b8b71f33de4.png";